import React, { useState, useEffect } from 'react';

const TextLoop = ({ children, interval = 2000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Get all children text content
  const texts = React.Children.toArray(children);
  
  useEffect(() => {
    if (texts.length <= 1) return;
    
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, interval);
    
    return () => clearInterval(timer);
  }, [texts.length, interval]);
  
  if (texts.length === 0) return null;
  
  return (
    <div className="text-loop-container">
      {texts[currentIndex]}
    </div>
  );
};

export default TextLoop;